<template>
  <div class="p_supply_module p_receive_box">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">业务类型</div>
                    <el-select v-model="listQuery.strBusitype" placeholder="" clearable size="small" >
                        <el-option label="安装" value="安装"></el-option>
                        <el-option label="维修" value="维修"></el-option>
                        <el-option label="移桩" value="移桩"></el-option>
                    </el-select>
                </div>
                <div class="screenInput">
                    <div class="flname">开始月份</div>
                    <el-date-picker size="small" value-format="yyyy-MM"
                        v-model="listQuery.startDate" :clearable="false"
                        type="month"
                        placeholder="">
                    </el-date-picker>
                </div>
                <div class="screenInput">
                    <div class="flname">结束月份</div>
                    <el-date-picker size="small" value-format="yyyy-MM"
                        v-model="listQuery.endDate" :clearable="false"
                        type="month"
                        placeholder="">
                    </el-date-picker>
                </div>
                <!-- <div class="screenInput">
                  <div class="flname">结算月</div>
                  <el-date-picker size="small" value-format="yyyy-MM"
                        v-model="dateRangeVal" :clearable="false"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        type="daterange"
                        placeholder="">
                    </el-date-picker>
                </div> -->
                <!-- <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div> -->
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- 筛选下拉框 -->
    <!-- <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="任务:">
            <el-select v-model="listQuery.bolUserSex" size="small" placeholder="">
              <el-option label="普工采集" value="普工采集"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采集平台:">
            <el-select v-model="listQuery.pingtai" size="small" placeholder="">
              <el-option label="宁波人才网" value="宁波人才网"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班地点:">
            <el-input v-model="listQuery.area" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageCrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box" v-if="checkPermission(['receivablesReport_page_list'],permissionLists)">
        <div class="r_act_box">
          <div class="r_act_left">
            <div class="r_act_item" v-if="!this.isNull(this.tableData)&&(checkPermission(['receivablesReport_export'],permissionLists))">
              <el-button size="small" type="primary" @click="exportHandle" :loading="btnLoading">导出</el-button>
            </div>
          </div>
        </div>
        <el-table ref="clueTable" class="re_table" :header-cell-style="{background:'#f2f2f2',color: '#909399'}" v-loading="tableLoading" border :max-height="tableHeight-100" :data="tableData" style="width:100%">
            <template v-for="(item,index) in tableTitle">
              <el-table-column :prop="item.StrColumId" :label="item.StrColumName" :key="index" :min-width="item.StrColumName.indexOf('结算月')>-1 ? '130px' : item.StrColumName.indexOf('业务类型')>-1?'100px':'160px'" align="center"
                :fixed="item.StrColumName=='施工队名称'">
                <template slot-scope="{row}">
                    <span v-if="(item.StrColumName.indexOf('结算月')>-1||item.StrColumName.indexOf('业务类型')>-1||item.StrColumName.indexOf('开票金额')>-1)">{{row[item.StrColumId]}}</span>
                    <span v-else-if="item.StrColumName.indexOf('应收款小计')>-1">{{ toFixesTwo(Number(row.InvoicAmount)-(Number(row.PriCashcollect)+Number(row.PriDiscollect)+Number(row.PriRetenMo)+Number(row.StrdiscountRate)))}}</span>
                    <span v-else-if="item.StrColumName.indexOf('已回款小计')>-1">{{ toFixesTwo((Number(row.PriCashcollect)+Number(row.PriDiscollect)+Number(row.PriRetenMo)+Number(row.StrdiscountRate)))}}</span>
                    <el-input v-else-if="item.StrColumName=='备注'" v-model="row[item.StrColumId]" size="small" clearable :disabled="row.isEditInput"></el-input>
                    <el-date-picker v-else-if="item.StrColumName=='开票日期'||item.StrColumName=='现金回款日期'||item.StrColumName=='贴现回款日期'||item.StrColumName=='贴现利息日期'||item.StrColumName=='质保金日期'" clearable size="small" value-format="yyyy-MM-dd"
                        v-model="row[item.StrColumId]"
                        type="date" :disabled="row.isEditInput"
                        placeholder="">
                    </el-date-picker>
                    <el-input v-else v-model="row[item.StrColumId]" type="number" size="small" clearable :disabled="row.isEditInput"></el-input>
                </template>
              </el-table-column>
            </template>
            <el-table-column align="center" label="操作" fixed="right" width="80px" class-name="re_act_box">
              <template slot-scope="{row}">
                <el-button v-if="row.isEditInput&&row.StrBusitype!='总计'&&(checkPermission(['receivablesReport_edit'],permissionLists))" type="info" size="mini" plain @click="editHandle(row)">编辑</el-button>
                <el-button v-if="!row.isEditInput&&row.StrBusitype!='总计'" type="info" size="mini" plain @click="saveEditHandle(row)">保存</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.currpage"
              :page-size="listQuery.perpage"
              @size-change="handleSizeChange"
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total,sizes,prev,pager,next,jumper"
              :total="total"
            ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="确定下载" :visible.sync="downVisible" width="450px">
      <div style="font-size: 14px;">请确认，是否下载导出数据？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="downVisible = false">取消</button>
        <button class="search" @click="confirmDown" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment'
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        isEditInput:true,
        downVisible:false,
        custPath: '',//导出文件下载路径
        tablePath: this.$store.state.EMP.tablePath,
        tableHeight: 0,
        showDropScreen:-1,
        pageCrumb:'应收款报表',
        activeName:'five',
        tableData: [],
        dateRangeVal:[],
        // 修改应收款金额
        editPriceQuery:{
            StrSettleDate:'',//结算月
            GdReceId:'',
            PriCashcollect:'',//现金回款
            PriDiscollect:'',//贴现回款
            StrdiscountRate:'',//贴现利率
            PriRetenMo:'',//质保金
            Totalofaccrec:'',//应收款小计
            StrRemark:'',//备注
            DtInvoicAmoDate:'',//开票日期
            DtPriCashDate:'',//现金回款日期
            DtPriDiscoDate:'',// 贴现回款日期~~~~
            DtdiscountDate:'',//贴现利息日期
            DtPriRetenDate:'',// 质保金日期
            TotalCollectrec:''// 应回款小计
        },
        listQuery:{
          strBusitype:'',// 业务类型
          strSettleDate:'',// 结算月
          startDate:'',//结算月开始时间
          endDate:'',//结算月结束时间
          currpage:1,
          perpage:10
        },
        // 表头参数
        titleQuery:{
          strTableId:'JB_report_Receivables', //JB_busi_UtilityBill (费用单) JB_busi_ConstrPerson（施工人员）JB_busi_ConstrTeam（施工队）JB_report_Receivables  应收款报表
          strIsFixed:''
        },
        exportQuery:{},
        btnLoading:false,
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        // 按钮权限参数
        butQuery:{
          path:'/receivablesReport',
          powerEnName:'supplierManage'
        },
        permissionLists:[]
      }
    },
    created() {
      this.calHeight();
      let lastDate = moment().subtract(1,'months').format("YYYY-MM")
      this.listQuery.strSettleDate = lastDate
      this.listQuery.startDate = lastDate//结算月开始时间
      this.listQuery.endDate = lastDate//结算月结束时间
      this.getButtonPower()
    },
    methods: {
      checkPermission,
        // 获取按钮权限
        getButtonPower(){
          let that = this
          xz.getbtnPowerIdBypage(this.butQuery).then(res => {
            // console.log('按钮',res)
            if(res.status == 'ok'){
              let resmsg = res.msg
              if(!this.isNull(resmsg)){
                for (let index = 0; index < resmsg.length; index++) {
                  let element = resmsg[index];
                  this.permissionLists.push(element.Enname);
                }
                if(that.checkPermission(['receivablesReport_page_list'],that.permissionLists)){
                  that.getTableTitleLists()// 表头
                }
              }else{
                this.permissionLists = []
              }
            }else{
              this.permissionLists = []
            }
          })
        },
        calHeight() {
            this.tableHeight = Number(document.body.clientHeight);
            // console.log('height', this.tableHeight)
        },
        // 导出
        exportHandle(){
          this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
          this.exportQuery.currpage = 1
          this.exportQuery.perpage = 1000000
          this.btnLoading = true
          // console.log('ll',param)
          xz.OutputTeamList(this.exportQuery,this.titleQuery.strTableId).then(res => {
            // console.log('ll',res)
            if (res.status == 'ok') {
              this.custPath = res.stroutpath
              this.downVisible = true
            } else {
              this.$message({
                type: 'error',
                message: '导出失败，请稍后再试'
              })
              return false
            }
            this.btnLoading = false
          })
        },
        // 确定下载导出数据
        confirmDown() {
          let path = this.tablePath + this.custPath
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
          this.downVisible = false
        },
        // 保留两位小数
        toFixesTwo(num){
          let result = Number(Math.round(num *100)/100).toFixed(2);
          return result
        },
        // 保存
        saveEditHandle(row){
          // console.log(111,this.isNullNotZero(row.PriCashcollect))
            if(this.isNullNotZero(row.PriCashcollect)){
                this.$message({ type: 'warning', message: '请输入现金回款' })
                return false
            }
            if(this.isNullNotZero(row.PriDiscollect)){
                this.$message({ type: 'warning', message: '请输入贴现回款' })
                return false
            }
            if(this.isNullNotZero(row.StrdiscountRate)){
                this.$message({ type: 'warning', message: '请输入贴现利息' })
                return false
            }
            if(this.isNullNotZero(row.PriRetenMo)){
                this.$message({ type: 'warning', message: '请输入质保金' })
                return false
            }
            this.editPriceQuery = {
                StrSettleDate:row.StrSettleDate,//结算月
                GdReceId:row.GdReceId,
                PriCashcollect:row.PriCashcollect,//现金回款
                PriDiscollect:row.PriDiscollect,//贴现回款
                StrdiscountRate:row.StrdiscountRate,//贴现利率
                PriRetenMo:row.PriRetenMo,//质保金
                Totalofaccrec:Number(row.InvoicAmount)-(Number(row.PriCashcollect)+Number(row.PriDiscollect)+Number(row.PriRetenMo)+Number(row.StrdiscountRate)),//应收款小计
                StrRemark:row.StrRemark,//备注
                DtInvoicAmoDate:row.DtInvoicAmoDate,//开票日期
                DtPriCashDate:row.DtPriCashDate,//现金回款日期
                DtPriDiscoDate:row.DtPriDiscoDate,// 贴现回款日期~~~~
                DtdiscountDate:row.DtdiscountDate,//贴现利息日期
                DtPriRetenDate:row.DtPriRetenDate,// 质保金日期
                TotalCollectrec:Number(row.PriCashcollect)+Number(row.PriDiscollect)+Number(row.PriRetenMo)+Number(row.StrdiscountRate)// 应回款小计
            }
            xz.saveReportReceivableinf(this.editPriceQuery).then(res => {
                if (res.status == 'ok') {
                    this.$message({ type: 'success', message: '操作成功' })
                    this.getList()
                }else{
                    this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                }
            })
        },
        // 编辑
        editHandle(row){
          // console.log('11',row)
            row.isEditInput = false
        },
        // 获取表头
        getTableTitleLists(){
          xz.getEcustColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then(res => {
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            }else{
              this.tableTitle = []
            }
            // console.log('表头', res)
          })
        },
        // 获取列表
        getList(){
            this.tableLoading = true
            this.isSearchHandle = true
            // this.listQuery.startDate = this.dateRangeVal[0]//结算月开始时间
            // this.listQuery.endDate = this.dateRangeVal[1]//结算月结束时间
            xz.getReportReceivables(this.listQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                    this.tableData = res.msg
                    if(!this.isNull(res.msg)){
                        for (let i = 0; i < res.msg.length; i++) {
                            let element = res.msg[i];
                            this.$set(element,'isEditInput',true)
                        }
                    }
                    this.total = res.totalcount
                }else{
                  this.tableData = []
                  this.total = 0
                }
              this.tableLoading = false
              this.isSearchHandle = false
              this.$store.commit("setSupComTabsIsover", true);
            })
        },
        //分页
        handleCurrentChange(val){
            this.listQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getList()
        },
        // 搜索
        searchHandle(){
            this.listQuery.currpage = 1
            this.getList()
        },
        // 清空
        resetHandle(){
          this.listQuery = this.$options.data.call(this).listQuery
          let lastDate = moment().subtract(1,'months').format("YYYY-MM")
          this.listQuery.strSettleDate = lastDate
          this.listQuery.startDate = lastDate//结算月开始时间
          this.listQuery.endDate = lastDate//结算月结束时间
        },
        //筛选下拉
        dropDownScreen() {
            if (this.showDropScreen == -1) {
            this.showDropScreen = 1;
            } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1;
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
        },
        isNullDate(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN' || o.indexOf('1900-01-01') > -1;
        },
        isNullNotZero(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || (o+'') == '' || o == null || o == 'null' || o == 'NaN';
        }
    }
  }
</script>

<style scoped>
.p_clue_box{
    background-color: #fff;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
</style>
<style>
.p_receive_box .re_table .el-date-editor.el-input{
  width: 140px;
}
.p_receive_box .re_table .el-date-editor .el-input__prefix{
  display: none;
}
.p_receive_box .el-date-editor.el-input__inner{
    width: 260px!important;
}
.p_receive_box .el-input.is-disabled .el-input__inner{
    background-color: #fff;
    border-color: #fff;
    text-align: center;
}
.p_supply_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_supply_module .el-tabs{
    background-color: #fff;
    padding: 0 10px;
}
.p_supply_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_supply_module .screenInputs .screenInput .el-select .el-input__inner,
.p_supply_module .re_down_form.el-form--inline .el-form-item__content,
.p_supply_module .re_down_form .el-select,
.p_supply_module .re_down_form .el-form-item__content,
.p_supply_module .screenInput .el-input{
  width: 200px;
}
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 3px 0;
}
</style>